import React from "react";

const Hero = () => (
	<section className="bg-purple-100 py-20 text-center">
		<div className="max-w-4xl mx-auto px-4">
			<h2 className="text-4xl font-bold mb-4">
				Reliable IT Solutions for the Modern World
			</h2>
			<p className="text-lg text-slate-600 mb-6">
				Inovativa Company Limited delivers smart, scalable, and secure IT
				services to help you grow your business.
			</p>
			<a
				href="#contact"
				className="bg-red-900 text-white px-6 py-3 rounded shadow hover:bg-red-800"
			>
				Get in Touch
			</a>
		</div>
	</section>
);

export default Hero;
